import z from 'zod';
import { deployParamSchema } from '@redviking/argonaut-util/src/mes/deployParam.zod';
import { DeployParamKind } from '@redviking/argonaut-util/src/mes/deployParamKind';

const locationSchemaBase = z.object({
    id: z.string().uuid(),
});

/** this is a reference to a deployment param, not the value */
export const locationDeployParamSchema = deployParamSchema(z.object({
    deployParamId: z.string(),
    deployParamKind: z.literal(DeployParamKind.location),
}));

/** this is a reference to a deployment param, not the value */
export const locationSchema = z.union([ locationDeployParamSchema, locationSchemaBase.strict() ]);
